
export enum EstadosLinhaParaRecalcularEnum {
  NaFila = 'na_fila',
  Recalculando = 'recalculando',
  ErroAoRecalcular = 'erro_ao_recalcular',
  Concluido = 'concluido'
}

export enum EstadosParaGeracaoJornadaEnum {
  AGUARDE_ATUALIZACAO = 'Aguarde, atualizando..',
  SEM_JORNADA = 'Sem jornada'
}
